/* eslint-disable react-hooks/exhaustive-deps */
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';
import { getHhgSegments, updateHhgSegment } from 'modules/authorizations/store/actions/houseHoldGoods.actions';
import { UPDATE_HHG_SEGMENT_FAILURE } from 'modules/authorizations/store/types/houseHoldGoodsTypes';
import { getDistance } from 'utilities/googleMapsClient';
import { useEffect } from 'react';

const HhgAddressCard = props => {
  const [isLoading, setIsLoading] = useState(false);
  const [currentMoveMiles, setCurrentMoveMiles] = useState(0);

  const { segmentInfo, storageAddress, hideEdit, addresses, provinces, id, countries } = props;
  const tabs = [{ header: 'Start/End Locations', order: 1, iconPath: ['fas', 'truck-moving'] }];

  const createAddressName = address => {
    const provinceName = provinces.find(p => p.id === address.provinceId)?.title || '';
    const addressParts = [address.addressLine1, address.city, provinceName].filter(Boolean);
    return addressParts.length > 0 ? addressParts.join(', ') : '';
  };

  let addressesOptions = Array.isArray(addresses)
    ? addresses
        .map(s => ({
          id: s.addressId,
          title: createAddressName(s),
          ...s
        }))
        .filter(option => option.title)
    : [];

  const summaries = [
    {
      header: 'Start Location',
      accessorKey: 'startAddressId',
      type: 'dropdown-v2',
      options: addressesOptions.filter(s => s.excludeAddressFromSelection === false),
      required: false,
      value: segmentInfo ? segmentInfo.startAddressId : '',
      tab: 1
    },
    {
      header: 'End Location',
      accessorKey: 'endAddressId',
      type: 'dropdown-v2',
      options: addressesOptions.filter(s => s.excludeAddressFromSelection === false),
      required: false,
      value: segmentInfo ? segmentInfo.endAddressId : '',
      tab: 1
    },
    {
      header: 'Move Miles',
      type: 'number',
      required: false,
      tab: 1,
      hideInModal: true,
      value: currentMoveMiles
    }
  ];

  const updateFields = async (tab, values) => {
    setIsLoading(true);
    var request = {
      segmentInfo: { ...segmentInfo, startAddressId: values.startAddressId, endAddressId: values.endAddressId },
      storageAddress: { ...storageAddress }
    };

    var response = await props.updateHhgSegment(request);
    if (response.type === UPDATE_HHG_SEGMENT_FAILURE) {
      props.showToast('Failed to update destination/departure address, please try again later', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    }
    await props.getHhgSegments(id);
    setIsLoading(false);
    return true;
  };

  useEffect(() => {
    const fetchDistance = async () => {
      const originAddressObj = (addresses && addresses.find(a => a.addressId === segmentInfo.startAddressId)) ? addresses.find(a => a.addressId === segmentInfo.startAddressId) : {};
      const destinationAddressObj = (addresses && addresses.find(a => a.addressId === segmentInfo.endAddressId)) ? addresses.find(a => a.addressId === segmentInfo.endAddressId) : {};
      const originAddress = `${originAddressObj.line1 ? originAddressObj.line1 + ', ' : ''}${originAddressObj.city ? originAddressObj.city + ', ' : ''}${provinces ? provinces.find((p) => p.id === originAddressObj.provinceId)?.title + ', ' : ''}${countries ? countries.find((c) => c.id === originAddressObj.countryId)?.title : ''}`;
      const destinationAddress = `${destinationAddressObj.line1 ? destinationAddressObj.line1 + ', ' : ''}${destinationAddressObj.city ? destinationAddressObj.city + ', ' : ''}${provinces ? provinces.find((p) => p.id === destinationAddressObj.provinceId)?.title + ', ' : ''}${countries ? countries.find((c) => c.id === destinationAddressObj.countryId)?.title : ''}`;
      const distance = await getDistance({formattedAddress: originAddress}, {formattedAddress: destinationAddress});
      setCurrentMoveMiles(distance.text);
    };
    fetchDistance();
  }, [segmentInfo]);

  return (
    <EditableCard
      tabs={tabs}
      summaries={summaries}
      numColumns={2}
      updateFields={updateFields}
      isLoading={isLoading}
      hideEdit={hideEdit}
      authorizationId={props.id}
      addresses={addresses || []}
      showAddressCard={true}
    />
  );
};

const mapStateToProps = state => {
  const { provinces, countries } = state.enumerations.allEnums;
  return {
    provinces,
    countries
  };
};

export default compose(
  connect(mapStateToProps, {
    showToast,
    updateHhgSegment,
    getHhgSegments
  })
)(HhgAddressCard);
